import type { SpendAlertIntent } from '../services/spendAlertService';

export type SpendAlertIntentPreset = {
  id: SpendAlertIntent;
  label: string;
  blurb: string;
  categorySlug: string;
  categoryLabel: string;
};

/** Goal presets — pick intent first; timing comes next in the modal. */
export const SPEND_ALERT_INTENT_PRESETS: SpendAlertIntentPreset[] = [
  {
    id: 'cut_dining',
    label: 'Cut dining out',
    blurb: 'Heads-up before restaurant / takeout windows',
    categorySlug: 'dining',
    categoryLabel: 'Dining',
  },
  {
    id: 'cut_subscriptions',
    label: 'Review subscriptions',
    blurb: 'Catch renewals and unused trials early',
    categorySlug: 'subscriptions',
    categoryLabel: 'Subscriptions',
  },
  {
    id: 'cut_shopping',
    label: 'Pause shopping',
    blurb: 'Cool-down before typical shopping spurts',
    categorySlug: 'shopping',
    categoryLabel: 'Shopping',
  },
  {
    id: 'cut_entertainment',
    label: 'Spend less on fun',
    blurb: 'Nudge before nightlife / tickets / outings',
    categorySlug: 'entertainment',
    categoryLabel: 'Entertainment',
  },
  {
    id: 'general',
    label: 'General spend heads-up',
    blurb: 'Pattern-based reminder for any category',
    categorySlug: 'all',
    categoryLabel: 'All spending',
  },
];

export const SPEND_ALERT_DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'] as const;

/** Full day hours so users can pick any timing. */
export const SPEND_ALERT_HOURS = Array.from({ length: 24 }, (_, h) => h);

export const SPEND_ALERT_LEAD_OPTIONS = [1, 2, 3, 4] as const;

export function intentLabel(intent: SpendAlertIntent | string | undefined): string {
  const preset = SPEND_ALERT_INTENT_PRESETS.find((p) => p.id === intent);
  return preset?.label ?? 'Spend alert';
}

export function formatAlertHour(hour: number): string {
  const h = ((hour % 24) + 24) % 24;
  const suffix = h >= 12 ? 'pm' : 'am';
  const twelve = h % 12 === 0 ? 12 : h % 12;
  return `${twelve}${suffix}`;
}

export function intentFromCategorySlug(slug: string): SpendAlertIntent {
  if (slug === 'dining') return 'cut_dining';
  if (slug === 'subscriptions') return 'cut_subscriptions';
  if (slug === 'shopping') return 'cut_shopping';
  if (slug === 'entertainment') return 'cut_entertainment';
  return 'general';
}
